// extracted by mini-css-extract-plugin
module.exports = {"container":"e_15","floatingBox":"e_25","floatingAd":"e_35"};